import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import authReducer from '../services/auth/authSlice'
import userReducer from '../services/user/userSlice'
import branchReducer from '../services/branch/branchSlice'
import itemReducer from '../services/item/itemSlice'
import shopItemGroupReducer from '../services/item/shopItemGroupSlice'
import bankAccountReducer from '../services/fund/bankAccountSlice'
import orderReducer from '../services/order/orderSlice'
import reportReducer from '../services/report/reportSlice'
import financeReducer from '../services/finance/financeSlice'
import couponReducer from '../services/marketing/couponSlice'
import screenReducer from '../services/screen/screenSlice'

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  branch: branchReducer,
  item: itemReducer,
  shopItemGroup: shopItemGroupReducer,
  bankAccount: bankAccountReducer,
  order: orderReducer,
  report: reportReducer,
  finance: financeReducer,
  coupon: couponReducer,
  // Add more reducers here if needed
  screen: screenReducer,
})

// Config redux-persist
const persistConfig = {
  key: 'lt-shop-admin-app', // Key is required
  storage,
  stateReconciler: autoMergeLevel2,
  // Optionally, we can whitelist or blacklist specific reducers:
  whitelist: [
    'auth',
    'user',
    'branch',
    'item',
    'bankAccount',
    'order',
    'report',
    'finance',
    'coupon',
    'screen',
  ],
  // blacklist: ['item', 'order', 'report', 'finance'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

const persistor = persistStore(store)

export { store, persistor }
